<template>
    <div class="player-video-container">
        <div class="vue-player" v-if="videoId">
            <div class="player" id="player" :data-id="videoId"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Player",
    props: {
        videoId: {
            type: Number,
            required: true,
        },
        title: {
            type: String,
        },
        cover: {
            type: String,
        },
        isOutOfHours: {
            type: Boolean,
        },
        isTimeIsUp: {
            type: Boolean,
        },
        isTimeIsUpRemind: {
            type: Boolean,
        },
        isModalUnlock: {
            type: Boolean,
        },
    },
    data() {
        return {
            autoPlay: false,
            anthill: window.anthill,
        };
    },
    watch: {
        videoId(id) {
            if (id && window.__PLAYER) {
                if (
                    this.videoId &&
                    !this.isOutOfHours &&
                    !this.isTimeIsUp &&
                    !this.isModalUnlock
                ) {
                    this.initPlayer();
                }
            }
            // this.initPlayer();
        },
        isTimeIsUpRemind(val) {
            if (val && window.__PLAYER) {
                window.__PLAYER.pause();
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                }
            }
        },
        isOutOfHours(val) {
            if (val && window.__PLAYER) {
                window.__PLAYER.pause();
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                }
            } else if (
                !val &&
                window.__PLAYER &&
                !this.isTimeIsUp &&
                !this.isModalUnlock
            ) {
                this.autoPlay = true;
                window.__PLAYER.play();
            } else if (!val && !window.__PLAYER) {
                this.initPlayer();
            }
        },
        isTimeIsUp(val) {
            if (val && window.__PLAYER) {
                window.__PLAYER.pause();
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                }
            } else if (!val && window.__PLAYER && !this.isOutOfHours) {
                this.autoPlay = true;
                window.__PLAYER.play();
            } else if (!val && !window.__PLAYER && !this.isModalUnlock) {
                this.initPlayer();
            }
        },
        isModalUnlock(val) {
            if (val && window.__PLAYER) {
                if (window.__PLAYER) {
                    window.__PLAYER.pause();
                    if (document.fullscreenElement) {
                        document.exitFullscreen();
                    }
                }
            } else {
                this.initPlayer();
            }
        },
    },
    computed: {
        playerData() {
            return this.$store.getters.getPlayerData;
        },
    },
    methods: {
        initPlayer() {
            if (!this.isOutOfHours && !this.isTimeIsUp) {
                this.autoPlay = true;
            }

            let that = this;

            if (window.__PLAYER) {
                window.__PLAYER.destroy();
                window.__PLAYER = undefined;
            }

            const pContainerId = document
                .querySelector(".player")
                .getAttribute("id");

            if (pContainerId) {
                this.anthill.tvplayer3loader.loadPlayer(function (
                    _error,
                    _tvplayer3core
                ) {
                    if (_error) {
                        console.log("Loading error!");
                        return;
                    }

                    window.__PLAYER = _tvplayer3core.createPlayer();

                    window.__PLAYER.init({
                        container: "#" + pContainerId,
                        videoID: that.videoId,
                        seekToTime: 0,
                        endPointData: '/shared/player2withoutTokenizer/api.dist.php?@method={{method}}&id={{id}}',
                        endPointToken: '/tokenizer/token/{{id}}',
                        gplayerAccountId:
                            "AotLcG7O0IySPlFwVR9l8aRu.j06bC7gKvd07qoHXzf.67",
                        gstreamAccountId:
                            ".F4wq3hgS5eecNPg4Did0qdFPzfs128ifYRHR21h1Ij.r7",
                        autoplay: that.autoPlay,
                        volumeLevel: 1,
                        playerType: "video",
                        mediaData: {
                            title: that.title || null,
                            coverUrl: that.cover || null,
                        },
                        statistics: {
                            gemiusAccountId:
                                ".AFAsjwaDxwDzJjxm1_R_8U1.oNZvK8p87C_3Y8pSfz.N7",
                        },
                        useDataLayer: true,
                    });
                });
            }
        },
    },
    beforeMount() {
        if (window.__PLAYER) {
            window.__PLAYER.destroy();
            window.__PLAYER = undefined;
        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                if (
                    this.videoId &&
                    !this.isOutOfHours &&
                    !this.isTimeIsUp &&
                    !this.isModalUnlock
                ) {
                    this.initPlayer();
                }
            }, 0);
        });
    },
    unmounted() {
        if (window.__PLAYER) {
            window.__PLAYER.destroy();
            window.__PLAYER = undefined;
        }
    },
};
</script>
